import React from 'react';
import AsyncChipSelect from './AsyncChipSelect';
import _ from 'lodash';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import clsx from 'clsx';
import { withFormsy } from 'formsy-react';

function ChipSelectFormsy(props) {
  const importedProps = _.pick(props, [
    'children',
    'classes',
    'className',
    'defaultValue',
    'disabled',
    'fullWidth',
    'id',
    'name',
    'onBlur',
    'onChange',
    'onFocus',
    'required',
    'variant',
    'isMulti',
    'errorMessage',
    'color',
  ]);

  // An error message is returned only if the component is invalid
  const {
    description,
    errorMessage,
    value, // { alias, label }[]
    onSearchOptions,
    optionRenderer,
    label,
    disabled,
    isMulti,
  } = props;

  const textFieldProps = {
    label,
    disabled,
    InputLabelProps: {
      shrink: true,
    },
    variant: 'outlined',
  };

  // { value, label }
  const [selectedOptions, setSelectedOptions] = React.useState([]);

  function handleSelectOptions(options) {
    let newOptions = [];
    if (Array.isArray(options)) {
      setSelectedOptions(options);
      newOptions = options;
    } else {
      setSelectedOptions([options]);
      const reformattedOptions = isMulti ? [options] : options;
      newOptions = reformattedOptions;
    }
    props.setValue(newOptions);
    if (props.onChange) {
      props.onChange(newOptions);
    }
  }

  // value must be selected options with value and label
  React.useEffect(() => {
    if (Array.isArray(value)) {
      setSelectedOptions(value);
    } else {
      setSelectedOptions([value]);
    }
  }, [value]);

  const handleSearchOptions = async (query) => {
    const { data } = await onSearchOptions({ query });
    return Array.isArray(data) ? data.map(optionRenderer) : [];
  };

  const helperText = errorMessage || description;

  return (
    <FormControl
      error={Boolean((!props.isPristine && props.showRequired) || errorMessage)}
      className={clsx(
        props.className,
        'z-10',
        props.showRequired ? 'required' : '',
        props.showError ? 'error' : null,
      )}
      variant={importedProps.variant}
    >
      <AsyncChipSelect
        {...importedProps}
        placeholder={props.placeholder || props.label}
        getOptionLabel={(option) => option.label}
        getOptionValue={(option) => option.alias}
        value={selectedOptions}
        onChange={handleSelectOptions}
        onSearchOptions={handleSearchOptions}
        error={Boolean((!props.isPristine && props.showRequired) || errorMessage)}
        textFieldProps={textFieldProps}
      />
      {Boolean(helperText) && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}

export default React.memo(withFormsy(ChipSelectFormsy));
